"use client";

import { Link, useLocation } from "react-router-dom";

const allAreas = [
  { name: "Brickell", slug: "brickell", zip: "33129" },
  { name: "Aventura", slug: "aventura", zip: "33180" },
  { name: "Miami Beach", slug: "miami-beach", zip: "33139" },
  { name: "Coral Gables", slug: "coral-gables", zip: "33134" },
  { name: "Coconut Grove", slug: "coconut-grove", zip: "33133" },
  { name: "Doral", slug: "doral", zip: "33178" },
  { name: "Kendall", slug: "kendall", zip: "33176" },
  { name: "Pinecrest", slug: "pinecrest", zip: "33156" },
  { name: "Bay Harbor Islands", slug: "bay-harbor-islands", zip: "33154" },
  { name: "Key Biscayne", slug: "key-biscayne", zip: "33149" },
  { name: "South Miami", slug: "south-miami", zip: "33143" },
  { name: "North Miami Beach", slug: "north-miami-beach", zip: "33162" },
];

export default function QuartierCrossLinks() {
  const location = useLocation();
  const currentSlug = location.pathname.replace("/impact-windows-", "").replace("/", "");

  const filtered = allAreas.filter((a) => a.slug !== currentSlug);

  return (
    <section className="bg-[#fefce8] py-16">
      <div className="mx-auto max-w-6xl px-5">
        <h3 className="mb-2 text-center text-xs font-bold uppercase tracking-widest text-[#064e3b]/50">
          Service Areas
        </h3>
        <h2 className="mb-10 text-center text-2xl font-bold text-[#064e3b]">
          Impact Windows Across All Miami-Dade
        </h2>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
          {filtered.map((area) => (
            <Link
              key={area.slug}
              to={`/impact-windows-${area.slug}/`}
              className="group flex flex-col items-center rounded-xl border border-[#064e3b]/10 bg-white p-4 text-center transition hover:border-[#047857] hover:shadow-md"
            >
              <span className="mb-1 text-sm font-semibold text-[#064e3b] group-hover:text-[#047857]">
                {area.name}
              </span>
              <span className="text-xs text-[#064e3b]/50">{area.zip}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}